import { createFileRoute } from "@tanstack/react-router";
import { EthosPage, ethosHead } from "@/features/company-story";

export const Route = createFileRoute("/ethos")({
    component: EthosPage,
    head: ethosHead,
});
